import { FloatingOverlay } from '@floating-ui/react';
import styled from '@emotion/styled';
import { boxShadow, overlayColor } from '../../helpers/styleHelpers';
import { breakpoint } from '../../../themes/stena-recycling/breakpoint';
import { spacing } from '../../../themes/stena-recycling/spacing';
import { colors } from '../../../themes/stena-recycling/colors';

export const OverlayWrapper = styled(FloatingOverlay)`
  background-color: ${overlayColor};
  z-index: 100;
  display: flex;
  justify-content: flex-end;
  visibility: visible !important;
  opacity: 0;
  transition: opacity 150ms ease;
  /* FloatingOverlay defaults to \`overflow: auto\` via inline style. The overlay itself never
     needs to scroll - DrawerScrollableContent handles scrolling of the drawer's own content -
     so force it to \`hidden\` to avoid an extra (unnecessary) scroll container. */
  overflow: hidden !important;

  &[data-status='open'] {
    opacity: 1;
  }
`;

export const DrawerBody = styled.div<{ width?: string }>`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: ${({ width }) => width ?? '420px'};
  max-width: 100vw;
  background-color: ${colors.base.white};
  box-shadow: ${boxShadow};
  transform: translateX(100%);
  transition: transform 300ms ease-out;
  will-change: transform;

  &[data-status='open'] {
    transform: translateX(0);
  }

  &[data-status='close'] {
    transition-duration: 240ms;
  }

  @media (max-width: ${breakpoint.small}px) {
    width: 100vw;
  }
`;

export const DrawerHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  gap: ${spacing.small};
  padding: ${spacing.small};
  border-bottom: 1px solid ${colors.monochrome.grey20};
  flex-shrink: 0;
`;

export const DrawerTitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.tiny};
  min-width: 0;
`;

export const DrawerTitle = styled.h2`
  margin: 0;
  font-family: 'Stena Sans', sans-serif;
  font-weight: 700;
  font-size: 18px;
  line-height: 28px;
  letter-spacing: 0.1111em;
  text-transform: uppercase;
  color: ${colors.base.black};
`;

export const DrawerSubtitle = styled.span`
  font-size: 16px;
  line-height: 24px;
  color: ${colors.base.black};
`;

export const DrawerScrollableContent = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  overflow-y: auto;
  overscroll-behavior: contain;
`;

export const DrawerInner = styled.div`
  box-sizing: border-box;
  flex-grow: 1;
  padding: ${spacing.small};
  width: 100%;

  @media (max-width: ${breakpoint.small}px) {
    padding: ${spacing.xsmall};
  }
`;

export const DrawerFooter = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  flex-shrink: 0;
  padding: ${spacing.small};
  gap: ${spacing.xsmall};
  border-top: 1px solid ${colors.monochrome.grey20};

  @media (max-width: ${breakpoint.small}px) {
    flex-direction: column-reverse;
    align-items: stretch;
  }
`;
